// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal__35Tf4","select":"select__3xf1k"};